import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { FindThirdPartiesResult, ThirdPartiesFilter } from 'lib/services/thirdPartiesApiClient';
import { type UseQueryResult, useQuery } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { QUERY_KEYS } from 'utils/queryKeys';

export const useThirdParties = (filter: ThirdPartiesFilter): UseQueryResult<FindThirdPartiesResult> => {
  const notify = useAppNotifications();
  const { thirdPartiesApiClient } = useServices();

  return useQuery(
    QUERY_KEYS.thirdParties.filter(filter),
    async ({ signal }) => await thirdPartiesApiClient.find(filter, signal),
    {
      onError: error =>
        notify.error({
          message: 'There was an error while fetching third parties',
          description: error instanceof Error ? getErrorMessage(error) : undefined,
        }),
    },
  );
};
